import { StyleSheet } from "react-native";
import { theme } from "../../theme";
export const styles = StyleSheet.create({
    defaults: {
        color: theme.colors.greyscale.base,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    icon: {
        marginRight: theme.spacing.xsmall2,
    },
    background: {
        alignSelf: "flex-start",
        backgroundColor: theme.colors.light.base,
        padding: theme.spacing.xsmall2,
        borderRadius: theme.spacing.xsmall2,
    },
    ...Object.assign({}, ...Object.keys(theme.colors).map((accessor) => ({
        [accessor]: {
            color: theme.colors[accessor].base,
        },
    }))),
});
export const invertColors = {
    brand: theme.colors.brand.darkest,
    accent: theme.colors.accent.darkest,
    positive: theme.colors.positive.darkest,
    warning: theme.colors.warning.darkest,
    usp: theme.colors.usp.darkest,
};
//# sourceMappingURL=Message.styles.js.map